
import AdminTrans from "../components/admin/AdminTransaction";

export default function AdminTransaction() {
  return (
    <div>
      <AdminTrans />
    </div>
  );
}
